import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FrmSugerenciaComponent } from './frm-sugerencia.component';
import {RouterModule} from "@angular/router";
import {
  DxButtonModule, DxCheckBoxModule, DxDateBoxModule, DxSelectBoxModule, DxTextAreaModule, DxTextBoxModule,
  DxValidationSummaryModule,
  DxValidatorModule
} from "devextreme-angular";
import { ReCaptchaModule } from 'angular2-recaptcha';
@NgModule({
  imports: [
    CommonModule, RouterModule,
    DxSelectBoxModule,
    DxCheckBoxModule,
    DxTextBoxModule,
    DxDateBoxModule,
    DxButtonModule,
    DxValidatorModule,
    DxValidationSummaryModule,
    DxTextAreaModule,
    ReCaptchaModule,
  ],
  declarations: [FrmSugerenciaComponent],
  exports: [FrmSugerenciaComponent]
})
export class FrmSugerenciaModule { }



// WEBPACK FOOTER //
// ./src/app/layouts/frm-sugerencia/frm-sugerencia.module.ts